import { render, staticRenderFns } from "./cartItem.vue?vue&type=template&id=3280baf5&scoped=true&"
import script from "./cartItem.vue?vue&type=script&lang=js&"
export * from "./cartItem.vue?vue&type=script&lang=js&"
import style0 from "./cartItem.vue?vue&type=style&index=0&id=3280baf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3280baf5",
  null
  
)

export default component.exports